import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'alert-box',
    templateUrl: './alert-box.component.html',
    styleUrls: ['./alert-box.component.scss'],
    standalone: false
})
export class AlertBoxComponent {
    @Input() hasImage = false;
    @Input() imageName = '';
    @Input() headerMessage = '';
    @Input() message = '';
    @Input() visible = false;
    @Input() position: "center" | "top" | "bottom" | "left" | "right" | "topleft" | "topright" | "bottomleft" | "bottomright" = 'bottom';
    @Input() closable = false;

    @Output() clicked = new EventEmitter<null>();

    onclick () {
        this.clicked.emit();
    }
}